import React from 'react'
import { styled, Typography as MIUTypography } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { columns } from './columns'
import moment from 'moment'
import './index.css'

const CustomMUIDatatable = styled(MUIDataTable)(
  ({ theme }) => `
  padding: ${theme.spacing(0, 0, 0, 1)};
`
)
const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1.1em',
  fontWeight: 650,
  paddingBottom: 6,
  paddingTop: 6,
}))

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTableHeadCell: {
        styleOverrides: {
          data: {
            fontSize: '.9em',
            fontWeight: 600,
            textTransform: 'uppercase',
            color: '#011339',
          },
        },
      },
    },
  })

export default function GenerateReportComponent({ headers, reportData }) {
  const options = {
    search: false,
    print: false,
    filter: true,
    viewColumns: true,
    download: true,
    downloadOptions: {
      filename: `Tree Report ${moment()}.csv`,
      separator: ',',
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    filterType: 'dropdown',
    selectableRows: 'none',
    textLabels: {
      pagination: {
        rowsPerPage: 'Filas por páǵina:',
        displayRows: 'de',
      },
    },
  }

  return (
    <ThemeProvider theme={getMuiTheme()}>
      <CustomMUIDatatable
        title={<Typography>Registros de árboles urbanos de la ciudad de Loja</Typography>}
        data={reportData.resultALL}
        columns={columns}
        options={options}
        sx={{ minHeight: 0, pr: 1 }}
      />
    </ThemeProvider>
  )
}
